module.exports = __webpack_public_path__ + "static/media/The-Sensitive-Future-Image.c9aaa49e.jpg";